<template>
  <div class="packs-list">
    <Loader v-if="loading" />

    <template v-else>
      <div v-if="packs.robux.length" class="packs-list__group">
        <!-- Заголовок нужен только когда групп две -->
        <div v-if="hasPremium" class="packs-list__group-title">{{ $t('packs.robuxCards') }}</div>
        <div class="packs-list__items">
          <GiftCard
            v-for="pack in packs.robux"
            :key="pack.id"
            :gift="pack"
            currency-code="rub"
            :active="current && current.id === pack.id"
            @click="$emit('updatePack', pack)"
          />
        </div>
      </div>

      <!-- Робуксы + Premium (category=premium): показываем, если поставщик их включил -->
      <div v-if="hasPremium" class="packs-list__group">
        <div class="packs-list__group-title">{{ $t('packs.premiumSubscription') }}</div>
        <div class="packs-list__items">
          <GiftCard
            v-for="pack in packs.premium"
            :key="pack.id"
            :gift="pack"
            currency-code="rub"
            :active="current && current.id === pack.id"
            @click="$emit('updatePack', pack)"
          />
        </div>
      </div>

      <div v-if="!packs.robux.length && !hasPremium" class="packs-list__empty">
        {{ $t('packs.noProducts') }}
      </div>
    </template>
  </div>
</template>

<script>
import './packsList.scss'

import GiftCard from '@/components/Gift/GiftCard/GiftCard.vue'
import Loader from '@/components/LoaderBar/LoaderBar.vue'
import { getPacks } from '@/utils/packsApi'

export default {
  name: 'PacksList',
  components: { GiftCard, Loader },
  props: {
    current: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      packs: { robux: [], premium: [] },
      loading: true
    }
  },
  computed: {
    hasPremium() {
      return this.packs.premium.length > 0
    }
  },
  created() {
    this.loadPacks()
  },
  methods: {
    async loadPacks() {
      this.loading = true

      try {
        this.packs = await getPacks()
      } catch (e) {
        this.packs = { robux: [], premium: [] }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
